exports = module.exports = require("../../../../../../../../../usr/lib/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".besidaMob-list__root--2VbOf{-ms-flex-direction:column;-webkit-box-direction:normal;-webkit-box-orient:vertical;display:-webkit-box;display:-ms-flexbox;display:flex;flex-direction:column;height:100%}.besidaMob-list__roleSwitcher--1rSV9{-webkit-box-shadow:0 1px 5px 0 rgba(0,0,0,.15);background:#fff;box-shadow:0 1px 5px 0 rgba(0,0,0,.15);position:relative;z-index:1}.besidaMob-list__content--2tMhy{-ms-flex:1;-webkit-box-flex:1;flex:1;min-height:1px;overflow:auto}", ""]);

// exports
exports.locals = {
	"root": "besidaMob-list__root--2VbOf",
	"roleSwitcher": "besidaMob-list__roleSwitcher--1rSV9",
	"content": "besidaMob-list__content--2tMhy"
};